export const blockIconsAudioandvideoPlayCircleFilled = (
	<span className='material-symbols-outlined'>play_circle_filled</span>
);
